import { CreditCard, Calendar, Clock } from "lucide-react";
import { withTranslation } from "react-i18next";
import React, { useEffect, useState, useCallback, useRef } from "react";
import {
  Card,
  CardBody,
  CardTitle,
  Col,
  Container,
  Form,
  FormGroup,
  Input,
  Label,
  Row,
  TabContent,
  TabPane,
  NavLink,
  Modal,
  ModalBody,
  ModalFooter,
  ModalHeader,
  Spinner,
  Dropdown,
  DropdownMenu,
  DropdownItem,
  DropdownToggle,
  ButtonDropdown,
  InputGroup,
  Badge,
  InputGroupText,
  Tooltip,
  FormFeedback,
  Alert,
  UncontrolledTooltip
} from "reactstrap";
import { sub } from "date-fns";
import CheckCircleRounded from "../../assets/images/icons/CheckCircleRounded";

const STRIPE_BILLING_URL =
  "https://billing.stripe.com/p/login/test_bIY4hidhydDW22I7ss";

const BillingPage = (props) => {
  const [loading, setLoading] = useState();
  const [portail_loading, setPortalLoading] = useState();
  const [subscription, setSubscription] = useState();
  const [error, setError] = useState();

  let user = props.userInfos;
  // let user = { email: "toto@tata.com" };

  const fetchSubscription = async () => {
    if (!user?.email) return;

    try {
      setLoading(true);
      const response = await fetch(
        "https://n8n.semecloud.tech/webhook/subscription-get",
        {
          method: "POST",
          headers: {
            "Content-Type": "application/json"
          },
          body: JSON.stringify({ email: user.email })
        }
      );

      if (!response.ok) {
        throw new Error("Failed to fetch subscription");
      }

      const data = await response.json();
      const sub = data.data[0];

      if (sub) {
        setSubscription({
          status: sub.status,
          plan: {
            amount: sub.plan.amount,
            currency: sub.plan.currency,
            interval: sub.plan.interval
          },
          current_period_end: sub.current_period_end,
          trial_end: sub.trial_end
        });
      } else {
        setSubscription(null);
      }
    } catch (err) {
      setError(
        err instanceof Error ? err.message : "Failed to fetch subscription"
      );
    } finally {
      setLoading(false);
    }
  };

  const fetchPortalUrl = async () => {
    if (!user?.email) return;

    try {
      setPortalLoading(true);
      const response = await fetch(
        `https://n8n.semecloud.tech/webhook/billing-portal?email=${user?.email}`,
        {
          method: "GET",
          headers: {
            "Content-Type": "application/json"
          }
        }
      );

      if (!response.ok) {
        throw new Error("Failed");
      }

      const portal = await response.json();
      console.log({ theportal: portal });

      if (portal) {
        window.location.href = portal.url;
      } else {
      }
    } catch (err) {
      setPortalLoading(false);
      setError(
        err instanceof Error ? err.message : "Failed to fetch subscription"
      );
    } finally {
      setPortalLoading(false);
    }
  };

  useEffect(() => {
    fetchSubscription();
  }, [user?.email]);

  if (loading) {
    return (
      <div style={{ textAlign: "center", fontSize: "14px" }}>
        <Spinner
          className="me-1"
          style={{ height: "15px", width: "15px" }}
          animation="border"
        />
        {props.t("Chargement") + "..."}
      </div>
    );
  }

  return (
    <div className="users-tabpane col-xxl-8 col-xl-9 mx-auto">
      <div className="row mx-auto col-xxl-9 col-xl-11">
        <Row className="align-items-center justify-content-between flex-row ">
          <Col>
            <div style={{ width: "fit-content" }}>
              <h4
                className="section-title font-primary mb-0"
                style={{ fontSize: "18px" }}
              >
                {props.t("Billing & Subscription")}
              </h4>
            </div>
          </Col>
        </Row>
        <Row className="mb-4 align-items-center">
          <Col></Col>
        </Row>
        <div
          style={{
            border: "1px solid",
            borderColor: "#E9ECEF",
            borderRadius: "10px",
            padding: "20px",
            margin: "0 auto"
          }}
        >
          <div className="col-auto">
            <div className="font-primary">
              <>
                <div>
                  <div style={{ fontWeight: "500" }}>
                    <h4
                      className="section-title font-primary mb-0"
                      style={{ fontSize: "18px" }}
                    >
                      {props.t("Abonnement actuel")}
                    </h4>{" "}
                    <span
                      className="badge p-2 my-2"
                      style={{
                        borderRadius: "10px",
                        backgroundColor:
                          subscription === undefined ? "#E5E4E2" : "#d7fee1",
                        color: subscription === undefined ? "black" : "#046c28"
                      }}
                    >
                      {subscription?.status === "trialing"
                        ? "Trial"
                        : subscription?.status === "active"
                        ? props.t("Actif")
                        : props.t("Aucun abonnement actif")}{" "}
                      {subscription?.status === "trialing" ||
                        (subscription?.status === "active" && (
                          <span style={{ color: "#046c28" }}>
                            <CheckCircleRounded width={24} height={24} />
                          </span>
                        ))}
                    </span>
                  </div>
                </div>
              </>
            </div>
          </div>

          {subscription && (
            <div className="flex items-center text-gray-600">
              <div className="flex items-center text-gray-600">
                <CreditCard className="w-5 h-5 me-3" />
                <span className="font-medium">
                  ${(subscription.plan.amount / 100).toFixed(2)}/
                  {subscription.plan.interval === "month"
                    ? props.t("mois")
                    : props.t("an")}
                </span>
              </div>

              <Calendar className="w-5 h-5 me-3" />
              <span>
                {props.t("Next billing date")} {": "}
                {new Date(
                  subscription.current_period_end * 1000
                ).toLocaleDateString()}
              </span>
              {subscription.trial_end && (
                <div className="flex items-center text-gray-600">
                  <Clock className="w-5 h-5 me-3" />
                  <span>
                    {props.t("Trial end")} {": "}
                    {new Date(
                      subscription.trial_end * 1000
                    ).toLocaleDateString()}
                  </span>
                </div>
              )}
            </div>
          )}
        </div>

        <div
          style={{
            border: "1px solid",
            borderColor: "#E9ECEF",
            borderRadius: "10px",
            padding: "20px",
            marginTop: "40px",
            color: "black"
          }}
        >
          <h4
            className="section-title font-primary mb-0"
            style={{ fontSize: "18px" }}
          >
            {props.t("Mode de paiement / Gérer mon abonnement")}
          </h4>
          <div>
            {subscription ? (
              <div className="space-y-4">
                <div className="bg-white rounded-lg p-6">
                  <p className="text-gray-600">
                    Manage your payment method on Stripe
                  </p>

                  <button
                    type="button"
                    className="view-button d-flex align-items-center"
                    style={{
                      marginTop: "10px",
                      marginLeft: "auto",

                      backgroundColor: "#563BFF"
                    }}
                    disabled={portail_loading}
                    onClick={() => fetchPortalUrl()}
                  >
                    {portail_loading ? (
                      <div style={{ textAlign: "center", fontSize: "14px" }}>
                        <Spinner
                          className="me-1"
                          style={{ height: "15px", width: "15px" }}
                          animation="border"
                        />
                        {props.t("Manage Billing")}
                      </div>
                    ) : (
                      props.t("Manage Billing")
                    )}
                  </button>

                  {/* <button
                    //href={STRIPE_BILLING_URL}
                    // target="_blank"
                    onClick={() => fetchPortalUrl()}
                    rel="noopener noreferrer"
                    className="mt-4 inline-flex items-center px-4 py-2 border border-gray-300 rounded-md shadow-sm text-sm font-medium text-gray-700 bg-white hover:bg-gray-50"
                  >
                    Manage Billing
                  </button> */}
                </div>
              </div>
            ) : (
              "--"
            )}
          </div>
        </div>
      </div>
    </div>
  );
};

export default withTranslation()(BillingPage);
